import ApiAcces from "@/shared/services/ApiAcces";
import type ILoginService from "../contracts/ILoginService";
import type LoginRequest from "../models/LoginRequest";
import type LoginResponse from "../models/LoginResponse";

export default class LoginService extends ApiAcces implements ILoginService {
  async login(loginRequest: LoginRequest): Promise<LoginResponse> {
    return await this.api.post(
      "/api/auth/login",
      loginRequest,
    );
  }
}
